import clsx from 'clsx';
import { useEffect, useState } from 'react';
import RangeSlider from '../range-filter';
import NumberInput from '../number-input';
import { toReadableNumber, toReadableNumberPrice } from '../../lib/utils';
import styles from './styles.module.scss';

export interface IFilterRangeSliderProps {
  min?: number;
  max?: number;
  errorFrom?: boolean;
  errorTo?: boolean;
  step?: number;
  title?: string;
  label?: string;
  valueTo?: number | null;
  valueFrom?: number | null;
  isShowSlider?: boolean; 
  onChangeTo(value: number | null): void;
  onChangeFrom(value: number | null): void;
  onBlur?: () => void;
  onFocus?: () => void;
}

export const FilterRangeSlider = (props: IFilterRangeSliderProps) => {
  const {
    min = 0,
    max = 0,
    errorTo,
    errorFrom,
    step = 1,
    title,
    label,
    valueTo,
    valueFrom,
    isShowSlider = true,
    onChangeTo,
    onChangeFrom,
    onFocus,
    onBlur,
  } = props;

  const [valueMin, setValueMin] = useState(0);
  const [valueMax, setValueMax] = useState(0);

  const isSelected = !!valueTo || !!valueFrom;

  useEffect(() => {
    setValueMin(+valueFrom!?.toString()?.replace(/\s/g, '') || min);
  }, [min, valueFrom]);

  useEffect(() => {
    setValueMax(+valueTo!?.toString()?.replace(/\s/g, '') || max);
  }, [max, valueTo]);

  const handleChange = (value: number[]) => {
    onChangeTo(value[1]);
    onChangeFrom(value[0]);
  };

  const handleChangeTo = (value: string) => {
    if (value === '') {
      return onChangeTo(null);
    }
    onChangeTo(+value.replace(/\s/g, ''));
  };

  const handleChangeFrom = (value: string) => {
    if (value === '') {
      return onChangeFrom(null);
    }
    onChangeFrom(+value.replace(/\s/g, ''));
  };

  const handleReset = () => {
    onChangeTo(null);
    onChangeFrom(null);
  };

  return (
    <div className={clsx(styles.container, isSelected && styles.containerActive)}>
      {title && <div className={styles.title}>{title}</div>}
      {label && <p className={styles.label}>{label}</p>}

      <div className={styles.sliderContainer}>
        <div className={styles.numberInputWrapper}>
          <NumberInput
            min={min}
            max={max}
            value={
              valueFrom === undefined
                ? ''
                : (toReadableNumberPrice(
                    +valueFrom!?.toString()?.replace(/(\s)|([^\d.]+)/g, ''),
                    false,
                  ) || '') + ''
            }
            decimal={step % 1 != 0}
            onChange={handleChangeFrom}
            placeholder={toReadableNumber(Math.round(min))}
            label='от'
            disableReset
            isMainPlaceholder
            error={errorFrom}
            onFocus={onFocus}
            onBlur={onBlur}
            // helper={
            //   +valueMin < min
            //     ? `Минимальное значение ${min}`
            //     : +valueMin > max
            //     ? `Максимальное значение ${max}`
            //     : ''
            // }
          />

          <NumberInput
            min={min}
            max={max}
            isMainPlaceholder
            value={
              valueTo === undefined
                ? ''
                : (toReadableNumberPrice(+valueTo!?.toString()?.replace(/\s/g, ''), false) || '') +
                  ''
            }
            decimal={step % 1 != 0}
            onChange={handleChangeTo}
            placeholder={toReadableNumber(Math.round(max))}
            disableReset
            label='до'
            error={errorTo}
            onFocus={onFocus}
            onBlur={onBlur}
            // helper={
            //   +valueMax < min
            //     ? `Минимальное значение ${min}`
            //     : +valueMax > max
            //     ? `Максимальное значение ${max}`
            //     : ''
            // }
          />
        </div>
        {isShowSlider && (
          <RangeSlider
            min={min}
            max={max}
            step={step}
            value={[+valueMin, +valueMax]}
            onChange={(value) => handleChange(value as number[])}
          />
        )}
      </div>

      {isSelected && (
        <div className={styles.resetButton}>
          <div />
          <button onClick={handleReset}>Сбросить</button>
        </div>
      )}
    </div>
  );
};
